class CouponCode extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('change', debounce((event) => {
          var minicartError = document.getElementById("mini-cart-error");
          minicartError.style.display="none"
          fetch(`/discount/${event.target.value}`)
          .then((response) => response.text())
          .then((responseText) => {
          });
          setTimeout(()=>{
            minicartError.innerHTML = ''
            minicartError.removeAttribute("style");
          },1000)
          
		}, 300))
	}
}

customElements.define('coupon-code', CouponCode);

function viewCartHandle(url) {
  let carUrl = url
  setTimeout(()=>{
      window.open(carUrl, "_self");
  },2000)
}


